<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="6">
          <v-sheet elevation="1">
            <v-treeview
              activatable
              :active.sync="active"
              selection-type="independent"
              :items="nodes"
              :load-children="expandNode"
              loading-icon="mdi-details"
              transition
            >
              <template v-slot:prepend="{ item }">
                <v-icon color="secondary">{{
                  recTypeIcon(item.id)
                }}</v-icon></template
              ></v-treeview
            ></v-sheet
          ></v-col
        >
        <v-col cols="6">
          <individual-expanded
            v-if="individual.isDefined"
            :individual="individual"
          ></individual-expanded>
        </v-col> </v-row
    ></v-container>
  </div>
</template>

<script>
import { Iri } from '@/rec-cache/rec-cache-types'
import { upProperties, downProperties } from '@/rec-cache/rec-cache-hierarchies'
import { recIcon } from '@/vue-wob-cache/vue-wob-icons'
import { RecIndividual } from '@/rec-cache/rec-cache-individual'
import IndividualExpanded from '@/components/IndividualExpanded.vue'

export default {
  components: { IndividualExpanded },
  props: { id: { type: String, default: () => '' } },
  data: () => ({
    nodes: [],
    stats: [],
    active: [],
    individual: new RecIndividual(),
  }),
  mounted: function () {
    console.log(
      'views.real-estate-view.mounted',
      this.id,
      this.individual.isDefined
    )

    const id = new Iri(this.id)
    const node = {
      id: id.value,
      name: this.$wob.read(id).label.value,
      children: [],
    }

    this.nodes.push(node)

    // console.time('tree')
    // const tree = this.traverseDown(new Iri(this.id))
    // this.nodes.push(tree)
    // console.log('views.real-estate-view.mounted', tree)
    // console.timeEnd('tree')
    // console.table(this.stats)
  },
  watch: {
    active: function (newActive) {
      console.time('active')
      const [id] = newActive
      console.log('components.real-estate-view.watch.active.id', id)
      this.individual = this.$wob.read(new Iri(id)) || new RecIndividual()
      console.timeEnd('active')
    },
  },
  methods: {
    recTypeIcon: function (id) {
      const individual = this.$wob.read(new Iri(id))
      return recIcon(individual.type)
    },

    expandNode: async function (node) {
      console.log('views.real-estate-view.methods.expand-node', node)
      const children = this.getChildren(new Iri(node.id))
      if (children.length) node.children.push(...children)
      else delete node.children
    },
    getChildren: function (id) {
      const upChildren = this.$wob
        .queryEdges({ target: id.value })
        .filter((e) => upProperties.includes(e.label.value))
        .map((e) => ({
          id: e.source.value,
          name: this.$wob.read(e.source).label.value,
          children: [],
        }))
      const downChildren = this.$wob
        .queryEdges({ source: id.value })
        .filter((e) => downProperties.includes(e.label.value))
        .map((e) => ({
          id: e.target.value,
          name: this.$wob.read(e.source).label.value,
          children: [],
        }))
      console.log(
        'views.real-estate-view.methods.expand-node.children',
        upChildren,
        downChildren
      )

      return [...upChildren, ...downChildren]
    },
    // Recursive traversal downwards. Parameter id is an Iri.
    traverseDown: function (id) {
      const t0 = Date.now()
      const individual = this.$wob.read(id)
      // TODO check if individual is found.
      const node = {
        id: id.value,
        name: individual.label.value,
        children: [],
      }
      console.log(
        'views.real-estate-view.methods.traverse-down',
        id,
        individual,
        node
      )
      const t1 = Date.now()

      // TODO more precise to name variables Edges rather nam Children...
      const upChildren = this.$wob
        .queryEdges({ target: id.value })
        .filter((e) => upProperties.includes(e.label.value))
      const downChildren = this.$wob
        .queryEdges({ source: id.value })
        .filter((e) => downProperties.includes(e.label.value))
      // TODO what if the relationship and its inverse are both present...

      console.log(
        'views.real-estate-view.methods.traverse-down.up-children',
        upChildren
      )
      console.log(
        'views.real-estate-view.methods.traverse-down.down-children',
        downChildren
      )

      const t2 = Date.now()
      // Only add children array if any child is present.
      // if (upChildren.length || downChildren.length) node.children = []
      node.children.push(...upChildren.map((e) => this.traverseDown(e.source)))
      node.children.push(
        ...downChildren.map((e) => this.traverseDown(e.target))
      )

      const t3 = Date.now()
      this.stats.push({ time: t3 - t0, edges: t2 - t1, recursion: t3 - t2 })

      return node
    },
  },
}
</script>
